import React from "react";

export const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? 24}
    height={props.height ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
      <path
        d='M12 12L7 7M12 12L17 17M12 12L17 7M12 12L7 17'
        stroke={props.stroke}
        strokeWidth={props.strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
  </svg>
);

export default CloseIcon;



